<ng-container *ngFor="let group of formControls.controls; index as i">
    <sbw-vehicles-details-row *ngIf="group.enabled" [index]="i" [form]="group" [vehicleName]="vehicleName"
        [trailerName]="trailerName"></sbw-vehicles-details-row>
</ng-container>
